import yup from 'src/libs/yup';

const MediaFilterSchema = yup.object().shape({
  name: yup.string().label('Descrição'),
});

export default MediaFilterSchema;
